import React, { Component } from 'react';
import { css } from 'glamor';
import * as styles from './search.style';
import searchIcon from '../../assets/icons/search_white.svg';
import { Link, Redirect, withRouter } from 'react-router-dom';
import * as translate from '../../assets/translations/translations';
import { set } from 'date-fns';
import CloseIcon from '../../assets/icons/close-small_darkblue.svg';
// import AutoSuggestSearchBarNew from './../commissionedresearch/parts/SearchBar';

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: props.searchkey || '',
            searchByLatest: props.searchByLatest,
            props: props,
            homepage: props.homepage,
            commissionedResearch: props.commissionedResearch,
            searchDropdownQuery: "",
        };
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        this.handleSearchQueryDropdownChange = this.handleSearchQueryDropdownChange.bind(this);
    }

    componentDidMount() {
        if (this.props.setTempSearchText) {
            this.props.setTempSearchText(this.state.searchText);
        }
    }



    updateInputValue(event) {
        this.setState({
            searchText: event.target.value
        });
        if (this.props.setTempSearchText) {
            this.props.setTempSearchText(event.target.value);
        }
    }

    handleKeyPress(target) {
        if (target.charCode == 13) {
            if (this.state.searchText !== "") {
                // this.props.history.push(`/articlesearch/${this.state.searchText}${this.state.searchByLatest ? '/searchByLatest' : ''}`);
                this.props.history.push(`/new-article-page/${this.state.searchText}${this.state.searchByLatest ? '/searchByLatest' : ''}`);
            }
        }
    }

    handleCheckboxChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleImgClk() {
        this.props.setFilterItems((prev) => ({ ...prev, "search": this.state.searchText }));
    }

    handleCloseIconClick() {
        if (this.props.setTempSearchText) {
            this.props.setTempSearchText("");
        }
        this.setState({ searchText: '' });
        // this.props.setFilterItems((prev) => ({ ...prev, "search": '' }));
    }

    handleSearchQueryDropdownChange = (event) => {
        const value = event.target.value;
        if (this.props.setSearchType) {
            this.props.setSearchType(value);
        }
        this?.props?.setSearchType(value);
        this.setState({ searchDropdownQuery: value });
        this.props.setFilterItems((prev) => ({ ...prev, "searchType": value }));
    }

    render() {
        return (
            <div>
                {this.state.homepage ?
                    <section {...css(styles.searchContainer)}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-12" role="region" aria-label={'Search by latest'}>
                                    <h1 {...css(styles.searchH2)} >{translate.strings.TR14}</h1>
                                    {/* <h2 {...css(styles.searchH2)}>{translate.strings.TR14}</h2> */}
                                    <div {...css(styles.searchInputContiner)}>
                                        <input aria-label="searchText" className='no-italic-placeholder' id="searchText" {...css(styles.searchInput)} onKeyPress={evt => this.handleKeyPress(evt)} type="text" value={this.state.searchText} onChange={evt => this.updateInputValue(evt)} placeholder={translate.strings.TR16} />
                                        <div {...css(styles.searchIconSection)}>
                                            {/* <Link aria-label="Search" to={this.state.searchText ? `/articlesearch/${this.state.searchText}${this.state.searchByLatest ? '/searchByLatest' : 
                                            ''}` : '/home'}> */}
                                            <Link aria-label="Search" to={this.state.searchText ? `/new-article-page/${this.state.searchText}${this.state.searchByLatest ? '/searchByLatest' : ''}` : '/home'}>
                                                <img src={searchIcon} {...css(styles.searchIcon)} alt={"Search Icon"} />
                                            </Link>
                                        </div>
                                    </div>
                                    {/* <label style={{ 'padding': '20px 10px' }} for="searchByLatest">
                                        <input aria-label="searchByLatest" name='searchByLatest' type="checkbox" checked={this.state.searchByLatest} onChange={this.handleCheckboxChange} style={{ 'transform': ' scale(1.5)' }} id="searchByLatest" />
                                        <span style={{ 'padding': '0 10px' }}>Search by latest</span>
                                    </label> */}
                                </div>

                            </div>

                        </div>
                    </section> :
                    <section {...css(styles.searchContainerDropdown)}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-12" role="region" aria-label={'Search by latest'}>
                                    {/* <div {...css(styles.searchInputContiner)}>
                                        <input aria-label="searchText" className='no-italic-placeholder' id="searchText" {...css(styles.searchInput)} onKeyPress={evt => this.handleKeyPress(evt)} type="text" value={this.state.searchText} onChange={evt => this.updateInputValue(evt)} placeholder={translate.strings.TR16} />
                                        {this.state.searchText.length > 0 && (
                                            <span
                                                {...css(styles.closeIcon)}
                                                aria-label="Clear search text"
                                            >
                                                <img src={CloseIcon} alt="Clear searched text" onClick={() => this.handleCloseIconClick()} width={16} height={16} />
                                            </span>
                                        )}
                                        <select aria-label="searchByLatest" name='searchByLatest' className='form-control' value={this.state.searchByLatest} onChange={this.handleCheckboxChange} style={{ 'width': '260px', 'height': '40px', 'borderRadius': '0 4px 4px 0', 'border': '1px solid #ced4da', 'backgroundColor': '#fff', 'color': '#495057' }}>
                                            <option value={false}>Search only in article titles</option>
                                            <option value={true}>Search throughout entire articles</option>
                                        </select>
                                        <div {...css(styles.searchIconSection)}> */}
                                    {/* <Link aria-label="Search" to={this.state.searchText ? `/articlesearch/${this.state.searchText}${this.state.searchByLatest ? '/searchByLatest' : ''}` : '/home'}> */}
                                    {/* {
                                                this.state.searchText?.length > 0 ?

                                                    <Link aria-label="Search" to={this.state.searchText ? `/new-article-page/${this.state.searchText}${this.state.searchByLatest ? '/searchByLatest' : ''}` : '/home'}>
                                                        <img src={searchIcon} {...css(styles.searchIcon)} alt={"search Icon"} onClick={() => this.handleImgClk()} />
                                                    </Link> : <img src={searchIcon} {...css(styles.searchIcon)} alt={"search Icon"} onClick={() => this.handleImgClk()} />
                                            }
                                        </div>
                                    </div> */}
                                    <div {...css(styles.searchInputContiner)}>
                                        <input aria-label="searchText" id="searchText" {...css(styles.searchInput)} onKeyPress={evt => this.handleKeyPress(evt)} type="text" value={this.state.searchText} onChange={evt => this.updateInputValue(evt)} placeholder={translate.strings.TR16} />
                                        {this.state.searchText.length > 0 && (
                                            <span
                                                {...css(styles.closeIcon)}
                                                aria-label="Clear search text"
                                            >
                                                <img src={CloseIcon} alt="Clear searched text" onClick={() => this.handleCloseIconClick()} width={16} height={16} />
                                            </span>
                                        )}
                                        <div {...css(styles.searchIconSection)}>
                                            {/* <Link aria-label="Search" to={this.state.searchText ? `/articlesearch/${this.state.searchText}${this.state.searchByLatest ? '/searchByLatest' : ''}` : '/home'}> */}
                                            {
                                                this.state.searchText?.length > 0 ?

                                                    <Link aria-label="Search" to={this.state.searchText ? `/new-article-page/${this.state.searchText}${this.state.searchByLatest ? '/searchByLatest' : ''}` : '/home'}>
                                                        <img src={searchIcon} {...css(styles.searchIcon)} alt={"search Icon"} /*onClick={() => this.handleImgClk()}*/ />
                                                    </Link> : <img src={searchIcon} {...css(styles.searchIcon)} alt={"search Icon"} /*onClick={() => this.handleImgClk()}*/ />
                                            }
                                        </div>
                                    </div>
                                    {/* <label style={{ 'padding': '20px 10px' }} for="searchByLatest">
                                        <input aria-label="searchByLatest" name='searchByLatest' type="checkbox" checked={this.state.searchByLatest} onChange={this.handleCheckboxChange} style={{ 'transform': ' scale(1.5)' }} id="searchByLatest" />
                                        <span style={{ 'padding': '0 10px' }}>Search by latest</span>
                                        </label> */}
                                </div>
                                <div {...css(styles.searchInputContiner)} style={{ marginLeft: '475px', marginTop: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ fontWeight: 400, fontSize: '16px' }}>Search: </span>
                                        <input
                                            type="radio"
                                            value="title"
                                            name="searchDropdownQuery"
                                            id="searchByTitle"
                                            checked={this?.props?.searchType ? this?.props?.searchType == 'title' : this.state.searchDropdownQuery == 'title'}
                                            onChange={this.handleSearchQueryDropdownChange}
                                            style={{ cursor: 'pointer' }}
                                        />
                                        <label htmlFor="searchByTitle" style={{ marginRight: '8px', marginBottom: 0, fontWeight: 400, fontSize: '16px', cursor: 'pointer' }}>Headline only</label>
                                        <input
                                            type="radio"
                                            value="full"
                                            name="searchDropdownQuery"
                                            id="searchByContent"
                                            checked={this?.props?.searchType ? this?.props?.searchType == 'full' : this.state.searchDropdownQuery == 'full'}
                                            onChange={this.handleSearchQueryDropdownChange}
                                            style={{ cursor: 'pointer' }}
                                        />
                                        <label htmlFor="searchByContent" style={{ marginBottom: 0, fontWeight: 400, fontSize: '16px', cursor: 'pointer' }}>Full article</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>}
            </div>
        );
    }
}

export default withRouter(Search)